import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// import Issuers from './modules/issuers';
import UI from './modules/ui';
import Auth from './modules/auth';

export const MUTATE_PAYLOAD = 'MUTATE_PAYLOAD';
Vue.use(Vuex);

interface IState {
  payload: object | undefined;
}
export default new Vuex.Store({
  state: {
    payload: undefined,
  },
  getters: {
    getPayload: ( state ) => state.payload,
  },
  mutations: {
    [MUTATE_PAYLOAD](state: IState, payload: object | undefined) {
      state.payload = payload;
    },
  },
  actions: {

  },
  modules: {
    ui: UI,
    // issuers: Issuers,
    auth: Auth
  },
  plugins: [createPersistedState({
    key: 'LuxTagBCM',
    paths: ['auth', 'ui'],
  })],
});
